import type { MccTierValue } from "@cpos/shared";

const TIER_COLORS = new Map<MccTierValue, string>([
  [1, "bg-emerald-500"],
  [2, "bg-blue-500"],
  [3, "bg-amber-500"],
  [4, "bg-muted-foreground"],
  ["unclassified", "bg-muted-foreground/50"],
]);

/** Bar fill for an ICP tier, so tier reads consistently across every card. */
export function tierColor(tier: MccTierValue): string {
  return TIER_COLORS.get(tier) ?? "bg-muted-foreground";
}
